import type { InvoiceDraft } from '../../types';

/** Fields highlighted when validation fails. */
export type DownloadRequiredField = 'number' | 'toAddress' | 'fromAddress';

function isBlank(value: string | undefined | null): boolean {
  return !String(value ?? '').trim();
}

function isFromBlank(invoice: InvoiceDraft): boolean {
  return isBlank(invoice.fromAddress) && isBlank(invoice.fromName);
}

function isToBlank(invoice: InvoiceDraft): boolean {
  return isBlank(invoice.toAddress) && isBlank(invoice.toName);
}

/** Bill From / Bill To — required before save. */
export function getRequiredFieldErrors(
  invoice: InvoiceDraft,
): Array<'fromAddress' | 'toAddress'> {
  const errors: Array<'fromAddress' | 'toAddress'> = [];
  if (isFromBlank(invoice)) errors.push('fromAddress');
  if (isToBlank(invoice)) errors.push('toAddress');
  return errors;
}

/** Returns empty array when the invoice can be downloaded. */
export function getDownloadFieldErrors(
  invoice: InvoiceDraft,
): DownloadRequiredField[] {
  const errors: DownloadRequiredField[] = [];
  if (isBlank(invoice.number)) errors.push('number');
  if (isFromBlank(invoice)) errors.push('fromAddress');
  if (isToBlank(invoice)) errors.push('toAddress');
  return errors;
}

const FIELD_ERROR_MESSAGES: Record<DownloadRequiredField, string> = {
  fromAddress: 'Enter your business details in Bill From.',
  toAddress: "Enter your client's details in Bill To.",
  number: 'Enter an invoice number.',
};

export function getFieldErrorMessage(field: DownloadRequiredField): string {
  return FIELD_ERROR_MESSAGES[field];
}

export function canDownloadInvoice(invoice: InvoiceDraft): boolean {
  return getDownloadFieldErrors(invoice).length === 0;
}
